const formatStringToNumber = (strNum) => {
  const num = parseFloat(strNum);
  return !Number.isNaN(num) ? num : 0;
};

const normalizeBetsHistory = (bets) =>
  bets?.map((bet) => ({
    ...bet,
    betSum: formatStringToNumber(bet.betSum),
    wins: bet.wins?.map(formatStringToNumber),
    freeSpinWins: bet.freeSpinWins?.map(formatStringToNumber),
    jackpotWins: bet.jackpotWins?.map(formatStringToNumber),
    tournamentWins: bet.tournamentWins?.map(formatStringToNumber),
    refunds: bet.refunds?.map(formatStringToNumber),
    canceled: bet.canceled?.map(formatStringToNumber)
  }));

export default normalizeBetsHistory;
